import { useCallback } from "react"
import { useStrapiNavigationMenus } from "./useStrapiNavigationMenus";

export const useStrapiNavigationMenu = id => {

  const menus = useStrapiNavigationMenus();

  const findMenu = useCallback(
    id => {
      return menus?.find(menu => {
        return menu?.id === id
      })
    },
    [menus]
  )

  const menu = findMenu(id);

  return menu
}
